import { DomainEvent } from "../model/domain-event.model";

export class ServiceRemovedDeviceEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor() {}
}